module.exports = __webpack_public_path__ + "static/media/Tauros_gaussian2.21fb0eb0.png";